export interface WordReplacementMap {
  [pattern: string]: string;
}

export function applyWordReplacements(
  text: string,
  replacements: WordReplacementMap
): { text: string; count: number } {
  const sorted = Object.entries(replacements).sort(
    (a, b) => b[0].length - a[0].length
  );

  let count = 0;
  for (const [pattern, replacement] of sorted) {
    const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(
      `(?<=^|[\\s,.!?;:()"-])${escaped}(?=$|[\\s,.!?;:()"-])`,
      "gi"
    );
    text = text.replace(regex, () => {
      count++;
      return replacement;
    });
  }

  // Fallback: simple case-insensitive match if no boundary matches found
  if (count === 0) {
    for (const [pattern, replacement] of sorted) {
      if (pattern === replacement.toLowerCase()) continue;
      const escaped = pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(escaped, "gi");
      const before = text;
      text = text.replace(regex, () => {
        count++;
        return replacement;
      });
      if (text !== before) break;
    }
  }

  return { text, count };
}
